import React, { useState, useEffect } from 'react';
import db from './db.js'
import ControlledCarousel from './carousel';

const Secret3 = (props) => {
  // States
  const [isLocked, setIsLocked] = useState(true);  // If lock is shown
  const [isCarouselActive, setIsCarouselActive] = useState(false);  // If carousel is active
  const [countdown, setCountdown] = useState(20);  // Countdown timer in seconds
  const [currentImageIndex, setCurrentImageIndex] = useState(0);  // Current image in the carousel
  const [isModalVisible, setIsModalVisible] = useState(false); // To track modal visibility
  const [lockCLicked, setLockClicked] = useState(false);
    
  const TIME=90 // how many seconds shoould the clock have?

  let DB = require ('./DB.json');

  const images = props.photos; // List of images for the carousel

  useEffect(() => {
    let timer;
    if (isCarouselActive) {
      // If carousel is active, start the countdown timer
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            // When countdown reaches 1, stop the carousel and reset to lock
            clearInterval(timer); // Stop the timer
            setIsCarouselActive(false);
            setIsLocked(true);
            return 0; // Reset countdown
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer); // Cleanup the interval when carousel is stopped
  }, [isCarouselActive]);

  useEffect(() => {
    let imageInterval;
    if (isCarouselActive) {
      // Change images every 5 seconds while the carousel is active
      imageInterval = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
      }, 5000);
    }
    return () => clearInterval(imageInterval); // Cleanup image interval when carousel stops
  }, [isCarouselActive]);

  const handleLockClick = () => {
    if (props.seen=="true" || lockCLicked) {
      // If carousel has already been viewed, show the modal
      setIsModalVisible(true);
      setLockClicked(true)
      
    } else {
      setCountdown(TIME); // Reset countdown to 20 seconds
      setCurrentImageIndex(0); // Reset carousel to the first image
      setIsLocked(false); // Hide the lock image
      setIsCarouselActive(true); // Activate the carousel
      if(!lockCLicked){
        db.pressed("","",props.albumid);         
      }
      setLockClicked(true)
      
    }
  };

  // Convert countdown from seconds to MM:SS format
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
    setIsLocked(true); // Reset to the lock image
  };


  
  return (
    <div style={styles.container}>
      {isLocked ? (
        <div style={styles.lockContainer}>
          <img
            src="lock.jpg"
            alt="Lock"
            style={styles.lockImage}
            onClick={handleLockClick}
          />
          {!lockCLicked ? <p style={styles.text}>Click the lock to view the album!</p> :  <p style={styles.text}></p>}
        </div>
      ) : isCarouselActive ? (
        <div style={styles.carouselContainer}>
            <div style={styles.countdown}>
            {formatTime(countdown)} {/* Display the countdown clock */}
          </div>
          {/* <img
            src={images[currentImageIndex]}
            alt="Carousel"
            style={styles.carouselImage}
          /> */}
          <ControlledCarousel photos={props.photos}/>
          
        </div>
      ) : (
        <div style={styles.lockContainer}>
          <img
            src="lock.jpg"
            alt="Lock"
            style={styles.lockImage}
            onClick={handleLockClick}
          />
          <p style={styles.text}>The time is up! Click the lock to try again.</p>
        </div>
      )}

      {/* Modal */}
      {isModalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2>You've already seen the album!</h2>
            <p style={{color:"black"}}>If you did not see the album somebody else has seen it before you!</p>
            <button style={styles.closeButton} onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles (inline)
const styles = {
  container: {
    marginTop:"40px",
    display: 'flex',
    // justifyContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#black',
    flexDirection: 'column',
    position: 'relative',
  },
  lockContainer: {
    textAlign: 'center',
  },
  lockImage: {
    width: '100px',
    cursor: 'pointer',
  },
  text: {
    fontSize: '18px',
    marginTop: '20px',
  },
  carouselContainer: {
    textAlign: 'center',
  },
  carouselImage: {
    width: '350px',
    height: '230px',
    objectFit: 'cover',
    borderRadius: '4px',
  },

  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '300px',
    color:"black"
  },
  closeButton: {
    marginTop: '20px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#a37905',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  countdown:{
    display:"inline-block",
    fontSize: '20px',
    color:"white",
    padding: '30px 20px',
    margin:"30px 30px",
    borderRadius: '50px',
    border:"solid",
    boderColor:"yellow",
    borderWidth:"2px",
    fontWeight:"bold",

  },
};

export default Secret3;
